var exports = {
  "kL": "ChannelSourcePreview.module__container___Z0U3MD",
  "mG": "ChannelSourcePreview.module__inline___Z0U3MD",
  "FS": "ChannelSourcePreview.module__textContainer___Z0U3MD",
  "S7": "ChannelSourcePreview.module__nameRow___Z0U3MD",
  "p": "ChannelSourcePreview.module__channelIcon___Z0U3MD",
  "oo": "ChannelSourcePreview.module__nameButton___Z0U3MD",
  "Ye": "ChannelSourcePreview.module__nameLink___Z0U3MD",
  "fh": "ChannelSourcePreview.module__nameText___Z0U3MD",
  "W$": "ChannelSourcePreview.module__subtext___Z0U3MD",
  "HR": "ChannelSourcePreview.module__subtextMuted___Z0U3MD",
  "G4": "ChannelSourcePreview.module__subtextPrimary___Z0U3MD",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___Z0U3MD",
  "$T": "ChannelSourcePreview.module__subtextChevron___Z0U3MD",
  "my": "ChannelSourcePreview.module__avatar___Z0U3MD",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___Z0U3MD",
  "bo": "ChannelSourcePreview.module__focusRingTight___Z0U3MD",
};

module.exports = exports;
